const SOURCE_COLORS = [
  '#60A5FA', '#A78BFA', '#FB7185', '#FBBF24',
  '#34D399', '#22D3EE', '#818CF8', '#FB923C'
];

function colorForDomain(domain: string) {
  let hash = 0;
  for (const ch of domain) hash = (hash * 31 + ch.charCodeAt(0)) & 0xffffffff;
  return SOURCE_COLORS[Math.abs(hash) % SOURCE_COLORS.length];
}

export function SourceDot({ domain }: { domain: string }) {
  const color = colorForDomain(domain);
  return (
    <span className="inline-flex items-center gap-1.5 text-xs" style={{ color: '#9898AA' }}>
      <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: color }} />
      {domain}
    </span>
  );
}
